<template>
  <section class="table-sampler-classification-noise">
    <d-form-row v-for="type in activeFields" :key="type" class="m-0 mb-1">
      <d-col cols="2">
        <label>{{ type.toUpperCase() }}</label>
        <d-select
          class="form-control"
          v-model="model[`${type}_object`]"
          @input="applyClassification(type)"
          required
        >
          <option v-for="option in getExposureRanges(type)" :key="option.label" :value="option">
            {{ option.label }}
          </option>
        </d-select>
      </d-col>
      <d-col cols="auto">
        <label>Considerações</label>
        <d-select
          class="form-control"
          v-model="model[`consideration_${type}`]"
          @input="handleManualConsideration(type)"
          required
        >
          <option v-for="option in getNormativeValues('technicalConsideration')" :key="option" :value="option">
            {{ option }}
          </option>
        </d-select>
      </d-col>
      <d-col cols>
        <label>Recomendação</label>
        <d-select
          class="form-control"
          v-model="model[`recomendation_${type}`]"
          required
        >
          <option v-for="option in getNormativeValues('recommendedAction')" :key="option" :value="option">
            {{ option }}
          </option>
        </d-select>
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="12">
        <label>Recomendação da exposição</label>
        <textarea
          class="form-control"
          v-model="model.exposition_recomendation"
          required
        />
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import { mapActions } from 'vuex';

import Events from '_utils/events';
import { cloneDeep } from '_utils';
import { VIBRATION_CLASSIFICATION, _LOAD_MODEL_, _UPDATE_SAMPLE_CRITERION_VIBRATION_ } from '../../SampleModel';

export default {
  name: 'Sample-Classification-Vibration',
  props: {
    classification: {
      type: Object,
      default: null,
    },
  },
  computed: {
    levels() {
      const classificationSettings = this.$store.state.settings.riskClassifications?.vibration || null;
      const currentNorm = this.currentCriterion === 'AREN/VDVR' ? 'nho10' : 'nho09';

      return classificationSettings?.[currentNorm]?.levels || {};
    },
    activeFields() {
      return this.currentCriterion === 'AREN/VDVR' ? ['vdvr', 'aren'] : ['aren'];
    },
  },
  data() {
    return {
      model: cloneDeep(VIBRATION_CLASSIFICATION),
      currentCriterion: null,
    };
  },
  methods: {
    ...mapActions(['getSettings']),
    getExposureRanges(type) {
      const key = type.toUpperCase();
      return Object.entries(this.levels).map(([levelKey, level]) => {
        const { min, max } = level;
        const label = max !== undefined
          ? `${min?.[key] || 0} a ${max[key]}`
          : `acima de ${min?.[key]}`;

        return { value: label, label, levelKey };
      });
    },
    getNormativeValues(field) {
      const values = Object.values(this.levels).map(l => l[field]).filter(Boolean);
      return [...new Set(values)];
    },
    applyClassification(type) {
      const criterion = this.model[`${type}_object`];
      if (!criterion) return;

      this.$set(this.model, type, criterion.label);
      const level = this.levels[criterion.levelKey];

      if (level) {
        this.$set(this.model, `consideration_${type}`, level.technicalConsideration);
        this.$set(this.model, `recomendation_${type}`, level.recommendedAction);
      }
    },
    handleManualConsideration(type) {
      const val = this.model[`consideration_${type}`];
      const match = Object.values(this.levels).find(l => l.technicalConsideration === val);
      if (match) {
        this.model[`recomendation_${type}`] = match.recommendedAction;
      }
    },
    clearClassification() {
      this.activeFields.forEach(field => {
        this.model[`consideration_${field}`] = null;
        this.model[`recomendation_${field}`] = null;
      });
    },
    handleCriterionChange(agent) {
      this.currentCriterion = agent?.criterion || null;
      this.$nextTick(() => {
        this.clearClassification();
      });
    },
    setModel() {
      if (this.classification) {
        this.model = this.classification;
      }
    },
  },
  mounted() {
    this.getSettings().then(() => this.setModel());
    this.setModel();
    const { sample } = this.$store.state.sample;
    this.currentCriterion = sample?.memory_field?.criterion || null;
    Events.$on(_LOAD_MODEL_, () => {
      this.setModel();
    });
    Events.$on(_UPDATE_SAMPLE_CRITERION_VIBRATION_, this.handleCriterionChange);
  },
  watch: {
    model: {
      handler(value) {
        const payload = cloneDeep(value);

        if (this.currentCriterion !== 'AREN/VDVR') {
          delete payload.vdvr;
          delete payload.vdvr_object;
        }

        this.$emit('update:classification', payload);
      },
      deep: true,
    },
  },
};
</script>

